export default "__VITE_ASSET__CvsoWY59__"